import React from "react"
import types from "prop-types"
import SurveyRecipientListHeader from "./SurveyRecipientListHeader"
import SurveyRecipientRow from "./SurveyRecipientRow"
import SurveyRecipientsEmptyState from "./SurveyRecipientsEmptyState"

const SurveyRecipientList = ({ recipientList }) => (
  recipientList.length === 0
    ? <SurveyRecipientsEmptyState />
    : (
      <>
        <SurveyRecipientListHeader />
        {recipientList.map((surveyRecipient) => (
          <SurveyRecipientRow key={surveyRecipient.id} surveyRecipient={surveyRecipient} />
        ))}
      </>
    )
)

SurveyRecipientList.propTypes = {
  recipientList: types.arrayOf(types.object).isRequired,
}

export default SurveyRecipientList
